<template>
    <div class="wrap">
        <div class="logo"></div>
        <div class="title">赛日SCM系统</div>
        <div>
            <span>{{username}}</span> | <span @click="outLogin" class="out">退出</span>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            username:'',
        }
    },
    async created(){
        let res =  await this.$Http.getUserInfo();
        if(res.code==0){
            this.username = res.data.username;
        }
    },
    methods:{
        outLogin(){
            localStorage.setItem('Authorization','');
            window.location.href = "/#/login";
        }
    }
}
</script>
<style scoped>
    .wrap {
        width: 100%;
        height: 60px;
        /* background-color: black; */
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }
    .logo{
        width: 80px;
        height: 80px;
    }
    .title{
        width: 60%;
    }
    .out{
       cursor: pointer; 
    }
</style>